import { useState } from "react";
import { IoIosArrowDropright } from "react-icons/io";
import { useStores } from "../../store";
import { Observer } from "mobx-react";

export default function SidebarCard(props) {
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [aptitude, setAptitude] = useState(false);
  const { MockStore } = useStores();

  const handleNumberClick = (number) => {
    setSelectedNumber(number);
    // console.log("hello", number);
    MockStore.setQuestionNumber(number);
    if (props.name === "Core Subject") {
      const branch = localStorage.getItem("branch");
      // console.log("hello", branch);
      MockStore.setSection(branch.toUpperCase());
    } else {
      MockStore.setSection(props.name.toUpperCase());
    }
    if (
      (Number(MockStore.questionNumber) ===
        MockStore.question[MockStore.section].length) &
      (MockStore.section === "CORE")
    ) {
      MockStore.setSubmit(true);
    } else {
      MockStore.setSubmit(false);
    }
    // console.log("hello", MockStore.questionNumber, MockStore.section);
  };

  // Generate an array from 1 to props.number
  const numbersArray = Array.from(
    { length: props.number },
    (_, index) => index + 1
  );

  return (
    <Observer>
      {() => {
        return (
          <div>
            {!aptitude && (
              <div
                onClick={() => setAptitude(true)}
                className={`flex cursor-pointer flex-row justify-between p-2 w-[90%]  items-center rounded-lg ${
                  props.name.toLowerCase() === MockStore.section.toLowerCase()
                    ? "bg-primary text-white"
                    : "bg-gray-300"
                }`}
              >
                <span>{props.name}</span>{" "}
                <span className="cursor-pointer h-max p-1">
                  <IoIosArrowDropright />{" "}
                </span>
              </div>
            )}{" "}
            {aptitude && (
              <div className="border border-primary p-2 w-[90%] rounded-lg">
                <span className="flex flex-row justify-between p-2 items-center">
                  <span className="text-sm font-semibold">{props.name}</span>
                  <button
                    onClick={() => setAptitude(false)}
                    className="text-primary text-sm"
                  >
                    view less
                  </button>
                </span>
                <div className="grid grid-cols-5 gap-1">
                  {numbersArray.map((number) => (
                    <div
                      key={number}
                      className={`flex justify-center items-center text-sm  border py-[5px] border-gray-300 rounded-full cursor-pointer ${
                        props.name !== "Core Subject" &&
                        (MockStore.Answer[props.name.toUpperCase()].includes(
                          String(number)
                        )
                          ? "bg-primary text-white"
                          : "")
                      } ${
                        props.name !== "Core Subject" &&
                        (MockStore.Answer[props.name.toUpperCase()].includes(
                          number
                        )
                          ? "bg-primary text-white"
                          : "")
                      } ${
                        props.name === "Core Subject" &&
                        (MockStore.Answer[MockStore.section].includes(
                          String(number)
                        )
                          ? "bg-primary text-white"
                          : "")
                      } ${
                        props.name === "Core Subject" &&
                        (MockStore.Answer[MockStore.section].includes(number)
                          ? "bg-primary text-white"
                          : "")
                      }`}
                      onClick={() => handleNumberClick(number)}
                    >
                      {number}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      }}
    </Observer>
  );
}
